import { render, staticRenderFns } from "./contactComponent.vue?vue&type=template&id=6d772032&scoped=true"
import script from "./contactComponent.vue?vue&type=script&lang=js"
export * from "./contactComponent.vue?vue&type=script&lang=js"
import style0 from "./contactComponent.vue?vue&type=style&index=0&id=6d772032&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d772032",
  null
  
)

export default component.exports